// extracted by mini-css-extract-plugin
module.exports = {"root":"Qi3NqO","icon":"w8PuQj"};